import { render, staticRenderFns } from "./WoundHealing.vue?vue&type=template&id=34cb99d0"
import script from "./WoundHealing.vue?vue&type=script&lang=js"
export * from "./WoundHealing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports